/* eslint-disable react/no-children-prop */
/* eslint-disable no-unused-vars */

/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Icon from "@mui/material/Icon";

// Material Dashboard 2 PRO React components
import MDBox from "components/Basics/MDBox";

// Material Dashboard 2 PRO React contexts
import { useMaterialUIController } from "context";
import { forwardRef } from "react";

// const DataTableHeadCell = forwardRef(
//   ({ width, children, sorted, align, staticPos, ...rest }, ref) => (
//     <DataTableHeadCellComponent
//       width={width}
//       children={children}
//       sorted={sorted}
//       align={align}
//       staticPos={staticPos}
//       ref={ref}
//       {...rest}
//     />
//   )
// );

const DataTableHeadCell = forwardRef(
	(
		{
			width = "auto",
			children,
			sorted = "none",
			align = "left",
			staticPos = false,
			className,
			hidden = false,
			colspan = "1",
			...rest
		},
		ref
	) => {
		const [controller] = useMaterialUIController();
		const { darkMode } = controller;

		return (
			<MDBox
				colSpan={colspan}
				ref={ref}
				className={staticPos ? `${className} tableCellHeadFlex` : `${className}`}
				component="th"
				width={width}
				py={1.5}
				px={3}
				sx={({ palette: { light }, borders: { borderWidth } }) => ({
					borderBottom: `${borderWidth[1]} solid ${light.main}`
				})}
			>
				<MDBox
					{...rest}
					position="relative"
					textAlign={align}
					color={darkMode ? "white" : "secondary"}
					opacity={0.7}
					sx={({ typography: { size, fontWeightBold } }) => ({
						fontSize: size.xxs,
						fontWeight: fontWeightBold,
						textTransform: "uppercase",
						cursor: sorted && "pointer",
						userSelect: sorted && "none"
					})}
				>
					{children}
				</MDBox>
			</MDBox>
		);
	}
);

export default DataTableHeadCell;
